// Keyed by platformAgentName: `amigo` on FoodAmigos, `assistant` on a partner's dashboard.
export default {
  label: {
    amigo: 'Perguntar ao Amigo',
    assistant: 'Assistente',
  },
  // The button's name while it shows a count of answers the person hasn't seen (the count itself is hidden from
  // screen readers).
  label_unread: {
    amigo_one: 'Pergunte ao Amigo, novidades: {{count}}',
    amigo_other: 'Pergunte ao Amigo, novidades: {{count}}',
    assistant_one: 'Assistente, novidades: {{count}}',
    assistant_other: 'Assistente, novidades: {{count}}',
  },
  unavailable_label: {
    amigo: 'Amigo indisponível',
    assistant: 'Assistente indisponível',
  },
  unavailable_text: {
    amigo: 'O Amigo não está disponível neste momento.',
    assistant: 'O assistente não está disponível neste momento.',
  },
};
